import { Instant } from "@js-joda/core";
import React from "react";
import { T } from "services/lang/LanguageService";
import useChartInDialogStore from "store/chart-in-dialog-store";

interface ChartInDialogButtonProps {
  identifier: string;
  identifiers?: string[];
  dateFrom?: Instant;
  dateTo?: Instant;
  header?: string;
}

const ChartInDialogButton = ({
  identifier,
  identifiers,
  dateFrom,
  dateTo,
  header,
}: ChartInDialogButtonProps) => {
  const { setDialogVisibility, setDateFrom, setDateTo, setHeader, setIdentifier, setIdentifiers } =
    useChartInDialogStore();

  const openDialog = () => {
    setIdentifier(identifier);
    setIdentifiers(identifiers || [identifier]);
    setDateFrom(dateFrom || Instant.now());
    setDateTo(dateTo || Instant.now());
    setHeader(header || T("word.chart"));
    setDialogVisibility(true);
  };

  return (
    <i
      className="pi pi-chart-line"
      onClick={e => {
        if (!e.ctrlKey) {
          openDialog();
        }
      }}
      style={{ cursor: "pointer" }}
    />
  );
};

export default ChartInDialogButton;
